import { cn } from '@/lib/utils'
import type { Equipment, EquipmentCondition, EquipmentStatus, WarrantyState } from '@/types/equipment'
import {
  CONDITION_CONFIG, LOCATION_CONFIG, STATUS_CONFIG, WARRANTY_CONFIG, formatIsoDate,
} from './equipmentUtils'

const pill = 'inline-flex items-center gap-1 whitespace-nowrap rounded-md border px-2 py-0.5 text-xs font-medium'

export function StatusBadge({ status, className }: { status: EquipmentStatus; className?: string }) {
  const cfg = STATUS_CONFIG[status] ?? { label: status, className: 'bg-gray-100 text-gray-700 border-gray-200' }
  return <span className={cn(pill, cfg.className, className)}>{cfg.label}</span>
}

export function WarrantyBadge({ state, until }: { state: WarrantyState; until?: string | null }) {
  const cfg = WARRANTY_CONFIG[state] ?? WARRANTY_CONFIG.unbekannt
  const title = until ? `bis ${formatIsoDate(until)}` : undefined
  return (
    <span className={cn(pill, cfg.className)} title={title}>
      {cfg.label}{until && (state === 'aktiv' || state === 'laeuft_ab' || state === 'vermutlich') ? ` · ${formatIsoDate(until)}` : ''}
    </span>
  )
}

export function ConditionDot({ condition, withLabel = true }: { condition: EquipmentCondition | null; withLabel?: boolean }) {
  if (!condition) return <span className="text-gray-400">–</span>
  const cfg = CONDITION_CONFIG[condition]
  return (
    <span className="inline-flex items-center gap-1.5 text-sm text-gray-700" title={cfg?.label}>
      <span className={cn('h-2.5 w-2.5 rounded-full', cfg?.dot ?? 'bg-gray-400')} />
      {withLabel && cfg?.label}
    </span>
  )
}

export function LocationCell({ item }: { item: Pick<Equipment, 'location_type' | 'location_label'> }) {
  const cfg = item.location_type ? LOCATION_CONFIG[item.location_type] : null
  const Icon = cfg?.icon
  return (
    <span className="inline-flex min-w-0 items-center gap-1.5 text-sm">
      {Icon && <Icon className="h-4 w-4 shrink-0 text-gray-400" />}
      <span className="truncate" title={item.location_label ?? undefined}>{item.location_label || '–'}</span>
    </span>
  )
}
